import { Link, useNavigate } from "react-router-dom";
import { LogOut } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function Navbar({ variant = "public" }) {
  const navigate = useNavigate();
  const isAdmin = variant === "admin";

  const logout = () => {
    localStorage.removeItem("simpa_token");
    localStorage.removeItem("simpa_user");
    navigate("/login");
  };

  return (
    <header className="sticky top-0 z-50 glass-nav">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2.5 group" data-testid="nav-logo">
          <img src="/logo-mark.png" alt="SIMPA" className="h-10 w-auto transition-transform duration-300 group-hover:scale-105 group-hover:-rotate-2" />
          <div className="leading-none">
            <div className="font-bold text-blue-600 tracking-tight text-lg" style={{ fontFamily: "'Outfit', sans-serif" }}>SIMPA</div>
            <div className="text-[9px] text-gold-600 font-semibold uppercase tracking-[0.18em]">Sistem Mandiri Paspor</div>
          </div>
        </Link>
        <nav className="flex items-center gap-2">
          {variant === "public" && (
            <>
              <Link to="/#faq" className="hidden md:inline px-3 py-2 text-sm text-slate-600 hover:text-slate-900">FAQ</Link>
              <Link to="/login" className="hidden md:inline px-3 py-2 text-sm text-slate-600 hover:text-slate-900" data-testid="nav-login-link">
                Masuk Petugas
              </Link>
              <Button asChild className="btn-lift rounded-full bg-blue-600 hover:bg-blue-700 text-white" data-testid="nav-start-btn">
                <Link to="/pemohon">Mulai Sekarang</Link>
              </Button>
            </>
          )}
          {isAdmin && (
            <Button variant="ghost" onClick={logout} className="text-slate-600" data-testid="nav-logout-btn">
              <LogOut className="w-4 h-4 mr-2" /> Keluar
            </Button>
          )}
        </nav>
      </div>
    </header>
  );
}
